import React from "react";

const columns = () => {
  return [
    {
      name: "id",
      fromItem: {
        type: "hidden"
      }
    },
    {
      title: '话题名称',
      name: 'title',
      searchItem: {},
      tableItem: {
        width: 200
      },
    },
    {
      title: '创建时间',
      name: 'createTime',
      tableItem: {
        width: 220
      },
    },
    {
      title: '有效日期',
      name: 'date',
      tableItem: {
        width: 212,
        type: 'custom',
        render: (text, record) => {
          let { start, end } = record
          let value = start + ' ~ ' + end
          return <div >{value}</div>
        }
      }
    },
  ]
}

const tableApi = (api = {}) => {
  return {
    path: 'topic/baseListByPage',
    ...api
  }
}

const topic = (self, api) => {
  return {
    type: 'diy',
    initialValue: [],
    columns: columns(),
    rowName: 'title',
    cols: {
      xs: 12,
      md: 12,
      xl: 12
    },
    tableApi: tableApi(api)
  }
}

export default topic
